import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';
import Signin from './features/signIn/signIn';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CookiesProvider } from 'react-cookie';

import reportWebVitals from './reportWebVitals';
import './index.css';
import Classroom from './features/classrooms/classroom';
import Dashboard from './features/dashboard/dashboard';
import ClassroomList from './features/classrooms/classroomList';
import './features/activation/activation.css';
import LessonSession from './features/classrooms/lessonSession';
import SingleSessionHistory from './features/classrooms/singleSessionHistory';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  
    <CookiesProvider>
      <Provider store={store}>
        <BrowserRouter>
          <Routes>
            <Route path="/signin" element={<Signin />} />
            <Route path="/dashboard" element={<Dashboard />}>
              <Route path="classes">
                <Route path="classList" element={<ClassroomList />} />
                <Route path="class/:id" element={<Classroom />} />
                <Route path="session/:id" element={<LessonSession />} />
                <Route path="sessionHistory/:id" element={<SingleSessionHistory />} />
              </Route>
            </Route>
            <Route exact path="/" element={<Signin />} />
          </Routes>
        </BrowserRouter>
      </Provider>
    </CookiesProvider>
  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
